module.exports = __webpack_public_path__ + "static/media/github-logo.dbd68783.svg";